import React, { useContext, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import Cropper from "react-cropper";
import { ProductContext, ModuleContext, ImageContext } from "../../provider";
import jQuery from "jquery";
import { fetchApi } from "../../../../config/core/Api";
import { AppContext } from "../../../../provider/AppProvider";
import globalComp from "../../../../global/components";
import { parse } from "url";
import path from "path";
import Slider, { createSliderWithTooltip } from "rc-slider";
import { ModuleInfoImage } from "../../../../Types";

let imageUrls: any = [];
const SliderWithTooltip: any = createSliderWithTooltip(Slider);

interface ImageCropperProps {
  mountingParentId: string;
  mountingParentBodyId: string;
  doneButtonId: string;
  selectedImage: ModuleInfoImage;
}

function ImageCropper({
  mountingParentId,
  mountingParentBodyId,
  doneButtonId,
  selectedImage,
}: ImageCropperProps) {
  const { printPaper, productType } = useContext(ProductContext);
  const { setIsLoading } = useContext(AppContext);
  const { isFilteredImage } = useContext(ModuleContext);
  const { handleStateForCropperUploads } = useContext(ImageContext);

  // ref
  const cropper = useRef<Cropper>(null);

  const [ratio] = useState<number>(printPaper.width / printPaper.height);
  const [isCropperLoading, setIsCropperLoading] = useState(true);
  const [angle, setAngle] = useState(0);

  useEffect(() => {
    document.getElementById(doneButtonId).addEventListener("click", handleCrop);
  }, []);

  function handleCrop() {
    if (cropper.current) {
      let tempFullImgName = parse(selectedImage.originalUrl).pathname;
      let tempImgName = path.basename(
        tempFullImgName,
        path.extname(tempFullImgName)
      );

      const dataUrl = cropper.current.getCroppedCanvas().toDataURL();
      var formData = new FormData();
      formData.append(
        "image",
        dataURLtoFile(
          dataUrl,
          `${Math.round(new Date().getTime() / 1000)}-${tempImgName}`
        )
      );
      setIsLoading(true);
      fetchApi({
        method: "POST",
        url: isFilteredImage
          ? "?action=upload_filtered_image"
          : "?action=upload_image",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((r) => {
          isFilteredImage
            ? handleStateForCropperUploads(
                r.data[0].filtered,
                selectedImage.originalUrl
              )
            : handleStateForCropperUploads(
                r.data[0].original,
                selectedImage.originalUrl
              );
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          setIsLoading(false);
        });
      jQuery(`#${mountingParentId}`).modal("hide");
      cropper.current.clear();
      cropper.current.reset();
    }
  }

  function dataURLtoFile(dataUrl, filename) {
    var arr = dataUrl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    let formatTypes = ["jpeg", "jpg", "png"];
    let selectedFormat = "";

    formatTypes.map((type) => {
      if (mime.includes(type)) {
        selectedFormat = `.${type}`;
      }
    });

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], `${filename}${selectedFormat}`, { type: mime });
  }

  return createPortal(
    <div
      className={"js-cropper-wrapper"}
      style={{
        position: "relative",
        height: 400,
        width: 400 * ratio,
      }}>
      {isCropperLoading && (
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            left: 0,
            top: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <globalComp.Spinner size={40} color={"gray"} />
        </div>
      )}
      <Cropper
        ref={cropper}
        src={selectedImage.originalUrl}
        style={{ height: 400, width: 400 * ratio }}
        minContainerHeight={400}
        minContainerWidth={400 * ratio}
        aspectRatio={
          productType == "only-image" || productType == "pop-art" ? 1 : NaN
        }
        guides={true}
        viewMode={2}
        modal={true}
        zoomOnWheel={false}
        ready={() => {
          setIsCropperLoading(false);
        }}
        crossOrigin={"anonymous"}
        checkCrossOrigin={false}
        rotatable={true}
      />
      <div
        className={"py-2 px-4 bg-light"}
        style={{ position: "absolute", width: "100%", bottom: -6 }}>
        <SliderWithTooltip
          value={angle}
          min={-180}
          max={180}
          step={1}
          onChange={(e) => {
            setAngle(e);
            cropper.current.rotateTo(e);
          }}
        />
      </div>
    </div>,
    document.getElementById(mountingParentBodyId)
  );
}

export default ImageCropper;
